import React, { useRef } from 'react';
import { Box, useMediaQuery } from "@mui/material"
import { motion, useScroll, useTransform } from "framer-motion";
import ContentSectionComponent from "../component/landing/content-section.component"
import MouseGlow from "../component/animations/MouseGlow";
import bannerProd from '../assets/image/landing/prducts-banner.png';

const LandingScreen = () => {
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const containerRef = useRef(null);

    // Unified Dark Theme - Fixed Background
    const backgroundColor = "#051937"; // Or a gradient if preferred

    const { scrollY } = useScroll();
    const backgroundY = useTransform(scrollY, [0, 2000], ['0%', '20%']); // Parallax effect

    return (
        <Box
            ref={containerRef}
            className={`${isSmallScreen ? "container-fluid container-xxxl" : ""}`}
            style={{ padding: 0, position: 'relative', backgroundColor: '#051937' }}
        >
            {/* Fixed Global Background (Military Style) */}
            <motion.div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100vh',
                    zIndex: -1,
                    backgroundColor: '#08244d',
                    backgroundImage: `url(${bannerProd})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'left center',
                    backgroundBlendMode: 'multiply',
                    y: backgroundY // Parallax movement
                }}
            />

            <MouseGlow />
            <ContentSectionComponent />
        </Box>
    )
}

export default LandingScreen
